import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import Navbar from 'components/Navbar';
import Footer from 'components/Footer';
import Prompt from 'components/Prompt';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { clearError } from 'store/error';
import './index.css';

const headerTransparentPaths = ['/'];
const noHeaderFooterPaths = ['/test/', '/assignment/', '/review/', '/katex', '/vocab/quiz/'];

function AppWrapper({ children }: { children: React.ReactNode }) {
    const [path, setPath] = useState('/');
    const [headerTransparent, setHeaderTransparent] = useState(true);
    const [noHeaderFooter, setNoHeaderFooter] = useState(true);

    const location = useLocation();
    const dispatch = useAppDispatch();
    const isFirstRender = useRef(true);
    const {
        error,
        message
    } = useAppSelector(state => state.error);
    
    useEffect(() => {
        // console.log(location.pathname);
        window.scrollTo(0, 0);

        let temp = false;
        for (const path of headerTransparentPaths) {
            if (location.pathname.includes(path)) {
                temp = true;
                break;
            }
        }
        setHeaderTransparent(temp);

        temp = false;
        for (const path of noHeaderFooterPaths) {
            if (location.pathname.includes(path)) {
                temp = true;
                break;
            }
        }
        setNoHeaderFooter(temp);
        
        setPath(location.pathname);

        // Clear errors on navigation only, not on first mount — an alert
        // dispatched just before the wrapper mounts (e.g. the sign-in
        // deactivation message) must survive until the user navigates.
        if (isFirstRender.current) {
            isFirstRender.current = false;
        }
        else {
            dispatch(clearError());
        }

        ReactGA.send('pageview');
        
    }, [location.pathname]);

    useEffect(() => {
        document.addEventListener('scroll', handleScroll);
    
        return () => {
            document.removeEventListener('scroll', handleScroll);
        }
    }, []);

    const handleScroll = (_event: UIEvent) => {
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
            // make header normal
            setHeaderTransparent(false);
        }
        else {
            // make header transparent
            setHeaderTransparent(true);
        }
    }

    if (noHeaderFooter) {
        return (
            <div className='appWrapper__child'>
                {error && message && <Prompt
                    title='Error'
                    text={message}
                    buttonText='CLOSE'
                    onButtonClick={() => dispatch(clearError())}
                />}
                {children}
            </div>
        );
    }

    return (
        <>
            <Navbar
                transparent={headerTransparentPaths.includes(path) && headerTransparent} 
            />
            <div className='appWrapper'>
                <div className='appWrapper__child'>
                    {error && message && <Prompt
                        title='Error'
                        text={message}
                        buttonText='CLOSE'
                        onButtonClick={() => dispatch(clearError())}
                    />}
                    {children}
                </div>
                <Footer />
            </div>
        </>
    );
}

export default AppWrapper;